<template>
  <div v-if="data">
    <div class="d-flex tw-justify-end tw-mb-[20px]">
      <TwBasePagination
        :page-count="data.total / data.limit"
        :pagination-params="data"
        :page-range="10"
        :showLimitInput="false"
        :margin-pages="0"
        :break-view-class="''"
        :click-handler="getData"
        :prev-text="''"
        :next-text="''"
      >
      </TwBasePagination>
    </div>

    <table class="table-type-1 tw-w-full">
      <tr v-for="item in data?.rows">
        <td width="20%" class="tw-text-center">
          {{ formatDate(item) }}
        </td>
        <td
          width="20%"
          class="tw-text-center"
          :class="
            item.company_ratings__rating < 0
              ? 'tw-text-[#FF2400]'
              : 'tw-text-[#23B14D]'
          "
        >
          {{ item.company_ratings__rating }}
        </td>
        <td>{{ item.company_ratings__description }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import GeneralService from "@/api/GeneralService";
import dayjs from "dayjs";

export default {
  data() {
    return {
      data: null,
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    ...mapState("userSettingModule", ["userSetting"]),
  },
  methods: {
    formatDate(item) {
      if (item.company_ratings__created_at) {
        return dayjs(item.company_ratings__created_at)
          .utc(true)
          .utcOffset(Number(this.userSetting.company__utc))
          .format(`${this.userSetting.company__tempalte_date} HH:mm`);
      } else {
        return "";
      }
    },
    getData(page = 1) {
      this.localLoading = true;
      GeneralService.get(`/super/companies/tab/rating/table/list/1`, {
        params: {
          page: page,
          limit: 15,
        },
      })
        .then((data) => {
          this.data = data.data.data;
        })
        .catch((e) => {
          this.$toast.error(e.response.data.message, { duration: 5000 });
        });
    },
  },
};
</script>
